<div class="page-body-wrapper">
  <div class="row">
    <div class="col-lg-12">
      <h2 class="page-title">Kalem Yetkileri</h2>

      <div class="employee-section">
        <mat-form-field class="employee-select" appearance="outline">
          <mat-label>Çalışan Seçimi</mat-label>
          <mat-select [(value)]="selectedEmployeeId" (selectionChange)="onEmployeeChange()">
            <mat-option [value]="null">-- Çalışan seçiniz --</mat-option>
            <mat-option *ngFor="let emp of employees" [value]="emp.id">
              {{ getEmployeeDisplayName(emp) }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="lists-row" *ngIf="selectedEmployeeId != null">
        <div class="list-panel left-panel">
          <h3 class="panel-title">Hali hazırda olan grup yetkileri</h3>
          <mat-form-field class="search-field" appearance="outline">
            <mat-label>Arama</mat-label>
            <input matInput [(ngModel)]="leftFilter" (keyup)="applyLeftFilter()" placeholder="">
          </mat-form-field>
          <div class="table-wrap">
            <table mat-table [dataSource]="leftDataSource" class="auth-table">
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox [checked]="isLeftSelected(row)"
                    (change)="toggleLeftSelect(row, $event.checked)" (click)="$event.stopPropagation()">
                  </mat-checkbox>
                </td>
              </ng-container>
              <ng-container matColumnDef="pgCode">
                <th mat-header-cell *matHeaderCellDef> PG </th>
                <td mat-cell *matCellDef="let row"> {{ row.pgCode }} </td>
              </ng-container>
              <ng-container matColumnDef="pgdCode">
                <th mat-header-cell *matHeaderCellDef> PGD </th>
                <td mat-cell *matCellDef="let row"> {{ row.pgdCode }} </td>
              </ng-container>
              <ng-container matColumnDef="wgCode">
                <th mat-header-cell *matHeaderCellDef> WG </th>
                <td mat-cell *matCellDef="let row"> {{ row.wgCode || '-' }} </td>
              </ng-container>
              <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef> Açıklama </th>
                <td mat-cell *matCellDef="let row">
                  {{ row.pgCodeDesc || '' }} {{ row.pgdCodeDesc || '' }} {{ row.wgCodeDesc || '' }}
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="leftDisplayedColumns"></tr>
              <tr mat-row *matRowDef="let r; columns: leftDisplayedColumns"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" [attr.colspan]="leftDisplayedColumns.length">
                  {{ loading ? 'Yükleniyor...' : 'Kayıt yok.' }}
                </td>
              </tr>
            </table>
          </div>
          <button mat-flat-button color="warn" class="action-btn remove-btn" (click)="removeSelected()">
            Sil / Kaldır
          </button>
        </div>

        <div class="list-panel right-panel">
          <h3 class="panel-title">Tüm tanımlı gruplar</h3>
          <mat-form-field class="search-field" appearance="outline">
            <mat-label>Arama</mat-label>
            <input matInput [(ngModel)]="rightFilter" (keyup)="applyRightFilter()" placeholder="">
          </mat-form-field>
          <div class="table-wrap">
            <table mat-table [dataSource]="rightDataSource" class="auth-table">
              <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row">
                  <mat-checkbox [checked]="isRightSelected(row)"
                    (change)="toggleRightSelect(row, $event.checked)" (click)="$event.stopPropagation()">
                  </mat-checkbox>
                </td>
              </ng-container>
              <ng-container matColumnDef="pgCode">
                <th mat-header-cell *matHeaderCellDef> PG </th>
                <td mat-cell *matCellDef="let row"> {{ row.pgCode }} </td>
              </ng-container>
              <ng-container matColumnDef="pgdCode">
                <th mat-header-cell *matHeaderCellDef> PGD </th>
                <td mat-cell *matCellDef="let row"> {{ row.pgdCode }} </td>
              </ng-container>
              <ng-container matColumnDef="wgCode">
                <th mat-header-cell *matHeaderCellDef> WG </th>
                <td mat-cell *matCellDef="let row"> {{ row.wgCode || '-' }} </td>
              </ng-container>
              <ng-container matColumnDef="description">
                <th mat-header-cell *matHeaderCellDef> Açıklama </th>
                <td mat-cell *matCellDef="let row">
                  {{ row.pgCodeDesc || '' }} {{ row.pgdCodeDesc || '' }} {{ row.wgCodeDesc || '' }}
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="rightDisplayedColumns"></tr>
              <tr mat-row *matRowDef="let r; columns: rightDisplayedColumns"></tr>
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" [attr.colspan]="rightDisplayedColumns.length">Kayıt yok.</td>
              </tr>
            </table>
          </div>
          <button mat-flat-button color="primary" class="action-btn add-btn" (click)="addSelected()">
            EKLE
          </button>
        </div>
      </div>

      <div class="save-section" *ngIf="selectedEmployeeId != null">
        <button mat-flat-button color="primary" class="save-btn" (click)="save()" [disabled]="saving">
          {{ saving ? 'Kaydediliyor...' : 'Kaydet' }}
        </button>
      </div>
    </div>
  </div>
</div>
